<div
    [popper]="onBoardingContent"
    [popperShowOnStart]="true"
    [popperHideOnClickOutside]="true"
    [popperAppendTo]="'market-groups'"
    [popperPlacement]="NgxPopperjsPlacements.BOTTOMSTART"></div>

<popper-content #onBoardingContent>
    <div class="multibuilder-onboarding-message">
        <div class="header">
            <span class="title">{{ sitecore.multiBuilder.header.text }} </span
            ><span class="badge badge-primary">{{ sitecore.globalMessages.NewBadgeText }}</span>
        </div>
        <div class="message">{{ sitecore.multiBuilder.onBoardingMessages.OnBoardingMessage }}</div>
        <div class="multi-builder-close" (click)="dismiss()">
            <vn-icon name="theme-ex" size="12" />
        </div>
    </div>
</popper-content>
